var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackToTopNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#262A33"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.71 10.208l-.582-.814.581.814zm.58 0l.582-.814-.581.814zm-6.709 5.606l6.71-4.793-1.163-1.627-6.71 4.792 1.163 1.628zm6.128-4.793l6.71 4.793 1.162-1.628-6.71-4.792-1.162 1.627zm.582 0a.5.5 0 01-.582 0l1.163-1.627a1.5 1.5 0 00-1.744 0l1.163 1.627z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 11v12",
    stroke: "#fff",
    strokeWidth: 2
  })));
}
export default __webpack_public_path__ + "static/back_to_top_new.1641a0b4.svg";
export { SvgBackToTopNew as ReactComponent };